import $ from 'jquery';
import Cookies from 'js-cookie';

// Let the document know when the mouse is being used
document.body.addEventListener(
	'mousedown',
	function() {
		document.body.classList.add( 'using-mouse' );
	}
);

// Re-enable focus styling when Tab is pressed
document.body.addEventListener(
	'keydown',
	function(event) {
		if (event.keyCode === 9) {
			document.body.classList.remove( 'using-mouse' );
		}
	}
);

function fontSizeDefault() {
	$( 'html' ).css( 'font-size', '1rem' );
}
function fontSizeBig() {
	$( 'html' ).css( 'font-size', '1.1rem' );
}
function fontSizeMajor() {
	$( 'html' ).css( 'font-size', '1.2rem' );
}

function contrastRatioIncrease() {
	$( '.main-button' ).css( 'color','#000' );
	$( '.bordered-box__title' ).css( 'color','#000' );
}

function contrastRatioNormal() {
	$( '.main-button' ).removeAttr( 'style' );
	$( '.bordered-box__title' ).removeAttr( 'style' );
}


$( '.wcag__contrast' ).click(
	function (){
		$( this ).toggleClass( 'button-contrast-on' );
		if ($( this ).hasClass( 'button-contrast-on' )) {
			contrastRatioIncrease();
			Cookies.set( 'contrast', 'on' );
		} else {
			contrastRatioNormal()
			Cookies.remove( 'contrast' );
		}
	}
);



if (Cookies.get( 'contrast' )) {
	contrastRatioIncrease();
	$( '.wcag__contrast' ).addClass( 'button-contrast-on' );
} else {
	contrastRatioNormal();
}

switch (Cookies.get( 'fontsize' )) {
	case 'big':
		fontSizeBig()
		$( '.wcag__button--plus' ).addClass( 'active' ).siblings().removeClass( 'active' );
		break;
	case 'major':
		fontSizeMajor()
		$( '.wcag__button--plus-plus' ).addClass( 'active' ).siblings().removeClass( 'active' );
		break;
	case 'default':
		fontSizeDefault()
		$( '.wcag__button--default' ).addClass( 'active' ).siblings().removeClass( 'active' );
		break;
}

$( '.button-fontsize' ).click(
	function () {
		$( '.wcag__fontsize-list' ).toggleClass( 'active' )
	}
)

$( '.wcag__button--default' ).click(
	function (){
		$( this ).addClass( 'active' ).siblings().removeClass( 'active' );
		if ($( this ).hasClass( 'active' )) {
			fontSizeDefault()
			Cookies.set( 'fontsize', 'default' );
		}
	}
)

$( '.wcag__button--plus' ).click(
	function (){
		$( this ).addClass( 'active' ).siblings().removeClass( 'active' );
		if ($( this ).hasClass( 'active' )) {
			fontSizeBig()
			Cookies.set( 'fontsize', 'big' );
		}
	}
)

$( '.wcag__button--plus-plus' ).click(
	function (){
		$( this ).addClass( 'active' ).siblings().removeClass( 'active' );
		if ($( this ).hasClass( 'active' )) {
			fontSizeMajor()
			Cookies.set( 'fontsize', 'major' );
		}
	}
)